export abstract class Event {
    abstract type: EventType;
    abstract createdAt: string;
}

export enum EventType {
    OrderActivity = 'OrderActivity',
    GiftCardActivity = 'GiftCardActivity'
}